import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function RouteListener() {
  const location = useLocation();
  useEffect(() => {
    // Send the current path to the parent window
    window.parent.postMessage(
      { path: location.pathname },
      process.env.REACT_APP_ADMIN || "*"
    );
  }, [location.pathname]);

  return null; // This component doesn't render anything
}

export default RouteListener;
